import { sumBy } from 'lodash';
import {
  CollapsibleGraphGroup,
  ComponentGraphNode,
  formatOtherLabel,
} from '@ardoq/graph';
import {
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
  measureNodeLabel,
} from '@ardoq/graph-labeling';
import {
  MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES,
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_PADDING as LEAF_NODE_PADDING,
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_VERTICAL_PADDING as OTHER_LABEL_VERTICAL_PADDING,
} from 'yfilesExtensions/styles/modernized/consts';
import { MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_WIDTH as OTHER_LABEL_WIDTH } from '../consts';
import { wrapString } from 'tabview/blocks/misc/string';

const otherLabelsHeight = (
  graphNode: ComponentGraphNode | CollapsibleGraphGroup
) => {
  const itemLabels = graphNode.getItemLabels();
  if (!itemLabels?.otherLabels?.length) {
    return 0;
  }

  const { otherLabels } = itemLabels;
  const wrappedOtherLabels = otherLabels
    .map(formatOtherLabel)
    .map(otherLabel =>
      wrapString(otherLabel, OTHER_LABEL_WIDTH, measureNodeLabel, MAX_LINES)
    );
  return (
    sumBy(
      wrappedOtherLabels,
      ({ length: lineCount }) =>
        lineCount * LINE_HEIGHT + 2 * OTHER_LABEL_VERTICAL_PADDING
    ) +
    (wrappedOtherLabels.length - 1) * LEAF_NODE_PADDING
  );
};
export { otherLabelsHeight };
